import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteSection from "../sections/DeleteSection";


const DeleteSectionAlert = (props) => {
    const { onCompletion, id, onClose } = props;


    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
            container_id="delete-section"
        >

            <DeleteSection onCompletion={onCompletion} id={id} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteSectionAlert;